"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toggleNodeClass(node, className, shouldAdd) {
    if (shouldAdd) {
        node.classList.add(className);
    }
    else {
        node.classList.remove(className);
    }
}
exports.default = toggleNodeClass;
//# sourceMappingURL=toggleNodeClass.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/toggleNodeClass.js
// module id = 10
// module chunks = 0